import {
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  SecurityContext,
  ViewChild,
} from '@angular/core'
import { DomSanitizer } from '@angular/platform-browser'
import { Router } from '@angular/router'
import { FooterNavigationService } from '../../footer/footer-navigation.service'
import { HelpService } from '../help.service'
import { forkJoin } from 'rxjs'
import { ChangeDetectorRef } from '@angular/core'
import { environment } from '../../../../environments/environment'

@Component({
  standalone: false,
  selector: 'vs-help-menu',
  templateUrl: './help-menu.component.html',
  styleUrls: ['./help-menu.component.scss'],
})
export class HelpMenuComponent implements OnInit {
  @ViewChild('siteTourOverlay') siteTourOverlay: ElementRef
  selectedHtmlElement: any
  @Output('helpMenuClicked') helpMenuClicked = new EventEmitter()
  safeURL: any
  validURL: boolean = false
  displayLoader: boolean = false
  pdfTrainingLink: string
  videoTutorialLink: string = ''

  constructor(
    private router: Router,
    private footerNavService: FooterNavigationService,
    private helpService: HelpService,
    private _sanitizer: DomSanitizer,
    private cRef: ChangeDetectorRef,
    private elRef: ElementRef,
    private domSanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    window.scroll(0, 0)
    this.fetchPDFVideo()
  }
  ngAfterViewInit() {
    if (
      this.elRef.nativeElement.querySelectorAll('.searchbox')[0] !== undefined
    ) {
      this.selectedHtmlElement =
        this.elRef.nativeElement.querySelectorAll('.searchbox')[0]
    }
    this.siteTourOverlay.nativeElement.setAttribute('style', `z-index:2`)
  }

  closeMenuOverlay() {
    this.helpMenuClicked.emit('clicked')
  }

  triggerFeedback() {
    this.closeMenuOverlay()
    this.router.navigate(['/feedback'])
  }
  triggerSiteTour() {
    //this.closeMenuOverlay();
    // this.footerNavService.openCloseSiteTourAction.next(true);
  }

  triggerVideoTutorial() {
    if (!this.displayLoader) {
      this.closeMenuOverlay()
      this.footerNavService.openCloseVideoTourAction.next(true)
      let videoObj = {
        url: this.videoTutorialLink,
        valid: this.validURL,
      }
      this.footerNavService.videoLinkUrl.next(videoObj)
    }
  }

  fetchPDFVideo() {
    this.displayLoader = true
    const requestslist = []
    requestslist.push(this.helpService.fetchTrainingLinkResponse())
    requestslist.push(this.helpService.fetchVideoLinkResponse())

    forkJoin(requestslist).subscribe(
      (response: any) => {
        const responsePDF = response?.responsePDF
        const responseVideoLink = response?.responseVideoLink
        this.generateLinkToPDF(responsePDF)
        this.generateLinkToYT(responseVideoLink)
        this.displayLoader = false
        this.cRef.detectChanges()
      },
      (error) => {
        this.displayLoader = false
        this.safeURL = ''
        this.validURL = false
        this.cRef.detectChanges()
      }
    )
  }

  generateLinkToPDF(responsePDF) {
    let pdfURL = responsePDF['media']?.downloadUrl
    const preUrl = environment.occBaseUrl // + environment.occPrefix + environment.occBaseSite;
    this.safeURL = preUrl + pdfURL
    // this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl(this.safeURL);
    this.pdfTrainingLink = this.domSanitizer.sanitize(
      SecurityContext.URL,
      this.safeURL
    )
    this.validURL = true
  }

  generateLinkToYT(responseVideoLink) {
    let videoURL = responseVideoLink['url']
    videoURL =
      videoURL +
      '?autohide=0&showinfo=0&controls=0&autoplay=1&fs=0&modestbranding=1'
    // videoURL =
    // videoURL +
    // '?controls=0&modestbranding=1&mute=0&nologo=0&rel=0&showinfo=0&autoplay=1';
    this.safeURL = videoURL
    this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl(videoURL)
    this.videoTutorialLink = this.safeURL
    this.validURL = true
  }
}
